export const couponList = [
  {
    key: "voucher",
    color: "#F56C6C",
    stock_name: "0.5元现金卷",
    stock_type: "NORMAL",
    value1: "500",
    value2: "1"
  },
  {
    key: "voucher",
    color: "#F56C6C",
    stock_name: "1元现金卷",
    stock_type: "NORMAL",
    value1: "1000",
    value2: "1"
  },
  {
    key: "voucher",
    color: "#F56C6C",
    stock_name: "2元现金卷",
    stock_type: "NORMAL",
    value1: "2000",
    value2: "1"
  }/* ,
  {
    key: "normal",
    color: "#409eff",
    stock_name: "满10元减1元优惠",
    stock_type: "NORMAL",
    value1: "1000",
    value2: "10000"
  },
  {
    key: "normal",
    color: "#409eff",
    stock_name: "满10元减2元优惠",
    stock_type: "NORMAL",
    value1: "2000",
    value2: "10000"
  },
  {
    key: "normal",
    color: "#409eff",
    stock_name: "满20元减1元优惠",
    stock_type: "NORMAL",
    value1: "1000",
    value2: "20000"
  },
  {
    key: "normal",
    color: "#409eff",
    stock_name: "满20元减2元优惠",
    stock_type: "NORMAL",
    value1: "2000",
    value2: "20000"
  },
  {
    key: "normal",
    color: "#409eff",
    stock_name: "满20元减3元优惠",
    stock_type: "NORMAL",
    value1: "3000",
    value2: "20000"
  },
  {
    key: "normal",
    color: "#409eff",
    stock_name: "满50元减3元优惠",
    stock_type: "NORMAL",
    value1: "3000",
    value2: "50000"
  },
  {
    key: "normal",
    color: "#409eff",
    stock_name: "满50元减5元优惠",
    stock_type: "NORMAL",
    value1: "5000",
    value2: "50000"
  },
  {
    key: "normal",
    color: "#409eff",
    stock_name: "满100元减5元优惠",
    stock_type: "NORMAL",
    value1: "5000",
    value2: "100000"
  },
  {
    key: "normal",
    color: "#409eff",
    stock_name: "满100元减10元优惠",
    stock_type: "NORMAL",
    value1: "10000",
    value2: "100000"
  },
  {
    key: "normal",
    color: "#409eff",
    stock_name: "满100元减20元优惠",
    stock_type: "NORMAL",
    value1: "20000",
    value2: "100000"
  },
  {
    key: "discount",
    color: "#04BE02",
    stock_name: "全场98折",
    stock_type: "discount",
    color: "#04BE02",
    value1: "98",
    value2: "1"
  },
  {
    key: "discount",
    color: "#04BE02",
    stock_name: "全场9折",
    stock_type: "DISCOUNT",
    color: "#04BE02",
    value1: "90",
    value2: "1"
  },
  {
    key: "discount",
    color: "#04BE02",
    stock_name: "全场88折",
    stock_type: "DISCOUNT",
    color: "#04BE02",
    value1: "88",
    value2: "1"
  },
  {
    key: "discount",
    color: "#04BE02",
    stock_name: "全场85折",
    stock_type: "DISCOUNT",
    color: "#04BE02",
    value1: "85",
    value2: "100000"
  },
  {
    key: "discount",
    color: "#04BE02",
    stock_name: "全场8折",
    stock_type: "DISCOUNT",
    color: "#04BE02",
    value1: "8",
    value2: "200000"
  } */
];
